import Joi from 'joi';
import baseApiSlice from '@/utilities/api/baseApiSlice';
import API_TAGS from '@/utilities/api/api-tag.enum';

const searchSchema = () =>
  Joi.object({
    orderIds: Joi.array().max(20),
  });

const trackAndTraceApi = baseApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    searchTrackingByOrderIds: builder.query({
      query: (values) => ({
        url: '/order-tracking/search',
        method: 'POST',
        body: values,
      }),
      transformResponse: (data) => data?.payload,
      providesTags: [API_TAGS.TRACK_N_TRACE],
    }),
  }),
});

const { useLazySearchTrackingByOrderIdsQuery } = trackAndTraceApi;

export { useLazySearchTrackingByOrderIdsQuery, trackAndTraceApi, searchSchema };
